document.addEventListener('DOMContentLoaded', function () {
 function createInfiniteSlider(
  container,
  speed = 2,
  direction = "left"
) {
  const track = container.querySelector(".slider-track");
  if (!track) return;

  let isPaused = false;
  let position = 0;

  container.addEventListener("mouseenter", () => (isPaused = true));
  container.addEventListener("mouseleave", () => (isPaused = false));

  function getSlideFullWidth(slide) {
    const style = window.getComputedStyle(slide);
    return (
      slide.offsetWidth +
      parseFloat(style.marginLeft) +
      parseFloat(style.marginRight)
    );
  }

  if (direction === "right") {
    const slides = track.children;
    if (slides.length > 0) {
      const lastSlideWidth = getSlideFullWidth(slides[slides.length - 1]);
      position = -lastSlideWidth;
      track.style.transform = `translateX(${position}px)`;
    }
  }

  function animate() {
    const slides = track.children;
    if (!isPaused && slides.length > 0) {
      if (direction === "left") {
        const firstSlide = slides[0];
        const w = getSlideFullWidth(firstSlide);

        position -= speed;

        if (position <= -w) {
          position += w;
          track.appendChild(firstSlide);
        }
      } else {
        const lastSlide = slides[slides.length - 1];
        const w = getSlideFullWidth(lastSlide);

        position += speed;

        if (position >= 0) {
          position -= w;
          track.prepend(lastSlide);
        }
      }

      track.style.transform = `translateX(${position}px)`;
    }

    requestAnimationFrame(animate);
  }

  animate();
}

  document.querySelectorAll(".js-infinite-slider").forEach((container) => {
    const speed = parseInt(container.dataset.speed || 2, 10);
    const direction = container.dataset.direction || "left";

    createInfiniteSlider(container, speed, direction);
  });


  const wrapper = document.querySelector('.faq-tabs-wrapper');
  if (!wrapper) return;

  const tabs = wrapper.querySelectorAll('.faq-tab-btn');
  const panels = document.querySelectorAll('.faq-tab-panel');

  const fakeSelect = wrapper.querySelector('.faq-tabs-select');
  const trigger = fakeSelect?.querySelector('.faq-tabs-select__trigger');
  const label = fakeSelect?.querySelector('.faq-tabs-select__label');
  const options = fakeSelect?.querySelectorAll('.faq-tabs-select__option');

  if (!tabs.length || !panels.length) return;

  const firstTab = tabs[0].dataset.tab;
  activateTab(firstTab);

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      activateTab(tab.dataset.tab);
    });
  });

  if (trigger && options) {

    trigger.addEventListener('click', () => {
      fakeSelect.classList.toggle('open');
    });

    options.forEach(option => {
      option.addEventListener('click', () => {
        activateTab(option.dataset.value);
        fakeSelect.classList.remove('open');
      });
    });

    document.addEventListener('click', e => {
      if (!fakeSelect.contains(e.target)) {
        fakeSelect.classList.remove('open');
      }
    });
  }

  panels.forEach(panel => {
    panel.querySelectorAll('.faq-question').forEach(question => {
      question.addEventListener('click', () => {
        const currentItem = question.closest('.faq-item');

        panel.querySelectorAll('.faq-item').forEach(item => {
          if (item !== currentItem) {
            item.classList.remove('active');
          }
        });

        currentItem.classList.toggle('active');
      });
    });
  });

  function activateTab(tabHandle) {

    tabs.forEach(tab => {
      tab.classList.toggle('active', tab.dataset.tab === tabHandle);
    });

    panels.forEach(panel => {
      const isActive = panel.dataset.tabContent === tabHandle;

      panel.classList.toggle('active', isActive);
      panel.style.display = isActive ? 'block' : 'none';

      if (isActive) {
        panel.querySelectorAll('.faq-item').forEach(item => {
          item.classList.remove('active');
        });
      }
    });

    if (label && options) {
      options.forEach(option => {
        const active = option.dataset.value === tabHandle;
        option.classList.toggle('active', active);
        if (active) {
          label.textContent = option.textContent;
        }
      });
    }
  }

});
